import React from "react";
import useObjectInput from "../../../hooks/useObjectInput";
import ErrorToast from "./ErrorToast";

// displays error toast
// allows user to perform different actions like show / hide errors or remove error highlight
const GOIManageError = ({ handleStopHighlight }) => {
  const {
    showErrors,
    detailedErrorLog,
    showErrorToast,
    highlight,
    handleSetShowErrors,
  } = useObjectInput();

  // If there are no errors, return null
  if (!detailedErrorLog?.length) return null;

  const mainClass = `goi-error-hide-stop-wrapper ${
    showErrorToast
      ? ""
      : "goi-error-outer-wrapper goi-error-hide-stop-wrapper-padding"
  } 
    `;

  return (
    <div className={mainClass}>
      {highlight && (
        <p className="goi-remove-error-highlight" onClick={handleStopHighlight}>
          remove error highlight
        </p>
      )}
      {!showErrorToast ? (
        // Button to toggle error display
        <p
          className={`goi-errors-set-error-info ${
            !highlight && "goi-error-flex-end"
          }`}
          onClick={() => handleSetShowErrors(!showErrors)}
        >
          {showErrors ? "hide errors" : "show errors"}
        </p>
      ) : (
        <ErrorToast />
      )}
    </div>
  );
};

export default GOIManageError;
